import { render, staticRenderFns } from "./SalesAgingDetail.vue?vue&type=template&id=6aa8fc33"
import script from "./SalesAgingDetail.vue?vue&type=script&lang=js"
export * from "./SalesAgingDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesAgingDetail.vue?vue&type=style&index=0&id=6aa8fc33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports